@if (useProsemirror) {
  <rt-box layout-vertical [class.text-answer-field__box--invalid]="hasError()">
    <rt-form-field>
      <rt-evaluation-field-label
        [title]="title()"
        [hint]="hint()"
        [required]="required()"
        [filled]="!!jsonControl().value"
      />

      <rt-wysiwyg
        prosemirrorGroupedConfig
        [config]="ProsemirrorGroupedConfig"
        [formControl]="jsonControl()"
        [withMinHeight]="true"
        [placeholder]="'app.evaluation_panel.your_answer' | translate"
        margin-top-small-x
      />
    </rt-form-field>
  </rt-box>

  @if (hasError()) {
    <div class="text-answer-field__error">
      {{ 'app.evaluation_panel.errors.basic_required' | translate }}
    </div>
  }
} @else {
  <rt-evaluation-multi-line-field
    [control]="control()"
    [title]="title()"
    [hint]="hint()"
    [required]="required()"
    [showValidationErrors]="showValidationErrors()"
  />
}
